import { useState } from 'react';
import Vendors from './Vendors';
import FindItem from './FindItem';

export default function Search({ setSearch, setVendorId }) {
  const [searching, setSearching] = useState(false);

  return (
    <>
      <div className="mb-2 has-text-centered">
        <button className="button is-link" onClick={() => setSearching(!searching)}>
          {!searching ? `Add Item ID` : `Add Vendor Item`}
        </button>
      </div>

      {!searching && <Vendors 
        setSearch={setSearch}
        setVendorId={setVendorId}
      />}

      {searching && <FindItem 
        setSearch={setSearch}
      />}
    </>
  )
}
